import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { hydrate } from 'react-dom';
import App from './app';

/**
 * TEST HOOK ONLY
 */
// eslint-disable-next-line import/prefer-default-export
export function renderClientRoot() {
  const { queryParams } = window.__STATE__;

  hydrate(
    <App initialState={window.__STATE__} queryParams={queryParams} />,
    document.getElementById('root'),
  );
}

renderClientRoot();
